import { Link } from "react-router-dom";
import { formatEventDate, gradientFor, styleForCategory } from "../lib/visual";
import type { Event } from "../types/api";
import styles from "./EventCard.module.css";

type Props = {
  event: Event;
  venueName?: string;
  venueCity?: string;
  variant?: "default" | "wide";
};

export default function EventCard({
  event,
  venueName,
  venueCity,
  variant = "default",
}: Props) {
  const date = formatEventDate(event.datetime);
  const category = styleForCategory(event.categoryId);
  const gradient = gradientFor(event.id, event.categoryId);

  return (
    <Link
      to={`/events/${event.id}`}
      className={`${styles.card} ${variant === "wide" ? styles.wide : ""}`}
    >
      <div className={styles.media} style={{ background: gradient }}>
        <span className={styles.glyph} aria-hidden>
          {category.glyph}
        </span>
        <span className={styles.categoryBadge}>{category.shortLabel}</span>
        <div className={styles.dateBadge}>
          <span className={styles.weekday}>{date.weekday}</span>
          <span className={styles.monthDay}>{date.monthDay}</span>
        </div>
      </div>
      <div className={styles.body}>
        <div className={styles.name}>{event.name}</div>
        {(venueName || venueCity) && (
          <div className={styles.venue}>
            {[venueName, venueCity].filter(Boolean).join(" · ")}
          </div>
        )}
        <div className={styles.meta}>
          <span className={styles.price}>
            From <strong>${Math.round(event.minPrice)}</strong>
          </span>
          <span className={styles.dot}>·</span>
          <span className={styles.time}>{date.time}</span>
        </div>
      </div>
    </Link>
  );
}
